export const legacyI18nMap = {
  CampaignSelector_List_Header: _TL_('Available campaigns: {{itemCount}}'),
  AdGroupSelector_List_Header: _TL_('Available ad groups: {{itemCount}}'),
  EmptyList_Content: _TL_('No items found'),
  EntitySelector_Pagination_Page: _TL_('Page: '),
  EntitySelector_Pagination_TotalPageCountText: _TL_(' of '),
  EntitySelector_Pagination_PreviousPageText: _TL_('Previous page'),
  EntitySelector_Pagination_NextPageText: _TL_('Next page'),
  EntitySelector_Search_Placeholder: _TL_('Search'),
  CampaignSelector_SelectCampaign: _TL_('Select campaign'),
  CampaignSelector_SelectCampaigns: _TL_('Select campaigns'),
  AdGroupSelector_SelectAdGroup: _TL_('Select ad group'),
  AdGroupSelector_SelectAdGroups: _TL_('Select ad groups'),
  CampaignSelector_Result_List_Header: _TL_('Selected campaigns: {{itemCount}}'),
  AdGroupSelector_Result_List_Header: _TL_('Selected ad groups: {{itemCount}}'),
  Result_Action_Bar: _TL_('Select all on this page'),
  'Select ad group(s)': _TL_('Select ad group(s)'),
  'Select an ad group': _TL_('Select an ad group'),
  'Selected ad groups: {{itemCount}}': _TL_('Selected ad groups: {{itemCount}}'),
  'Campaigns: {{itemCount}}': _TL_('Campaigns: {{itemCount}}'),
  Campaigns: _TL_('Campaigns'),
  'Ad groups': _TL_('Ad groups'),
  'Available ad groups: {{itemCount}}': _TL_('Available ad groups: {{itemCount}}'),
  'No results to display.': _TL_('No results to display.'),
  'Select all on this page': _TL_('Select all on this page'),
  'Remove all': _TL_('Remove all'),
  Done: _TL_('Done'),
  Cancel: _TL_('Cancel'),
  'Available Entity: {{itemCount}}': _TL_('Available Entity: {{itemCount}}'),
  'No items found': _TL_('No items found'),
  Search: _TL_('Search'),
  CampaignSelector_Result_Action_Bar: _TL_('Select all on this page'),
  'Found {{totalCount}} Results for {{searchText}}': _TL_('Found {{totalCount}} Results for {{searchText}}'),
  'No results found for {{searchText}}': _TL_('No results found for {{searchText}}'),
  AccountSelector_List_Header: _TL_('Available accounts: {{itemCount}}'),
  AccountSelector_SelectAccounts: _TL_('Select accounts'),
  AccountSelector_Result_List_Header: _TL_('Selected accounts: {{itemCount}}'),
};
